import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/views/Main'
import ApplyUntie from '@/views/ApplyUntie'
import Feedback from '@/views/Feedback'
import AppleAudit from '@/views/AppleAudit'
import StudentOperation from '@/views/StudentOperation'
import RegisterInfo from '@/views/RegisterInfo'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/apply/untie',
      name: 'ApplyUntie',
      component: ApplyUntie
    },
    {
      path: '/feedback',
      name: 'Feedback',
      component: Feedback
    },
    {
      path: '/apple/audit',
      name: 'AppleAudit',
      component: AppleAudit
    },
    {
      path: '/student/del',
      name: 'StudentOperation',
      component: StudentOperation
    },
    {
      path: '/report/register',
      name: 'RegisterInfo',
      component: RegisterInfo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js